export default __webpack_public_path__ + "static/media/bank_scb.08087d3e.svg";